// ranking-reveal 动画：揭晓状态 + 当前揭晓到第几项（0-based，按 rank 升序）。
import type { SceneData } from '../../api/types'
import type { RankingData } from './types'

export function rankingReveal(
  d: SceneData,
  time: number,
): { revealState: 'idle' | 'revealing'; revealIdx: number } {
  const data = d as unknown as RankingData
  const sorted = [...(data.items || [])].sort((a, b) => a.rank - b.rank)
  const revealInterval = 5
  const revealIdx = Math.min(Math.floor(time / revealInterval), sorted.length)
  if (revealIdx === 0 || revealIdx > sorted.length) {
    return { revealState: 'idle', revealIdx: 0 }
  }
  return { revealState: 'revealing', revealIdx: revealIdx - 1 }
}
